module.exports = __webpack_public_path__ + "img/icons-9.3e05704a.png";